import React from "react";
import './App.css';
import Weather from "./Weather";
import "./Weather.css";

export default function App() {
  return (
    <div className="App">
      <div className="container">
     <Weather defaultCity="London"/>
   <footer>
 
      This project was coded by <a href="https://www.linkedin.com/in/alice-arcourt-phd-5772728b/" target="_blank">Alice Arcourt</a>  and is {""}
     <a href="https://github.com/Lilie28/weather-app-react-final-project" target="_blank">
     open-sourced</a>
    
   </footer>
       </div>
    </div>
  );
}


